import React from "react";

const Testimonial = ({index, profilePicture, affiliation, name, quote}) => {
  const quoteIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none">
      <path
        d="M51.6963 34.4986C58.051 34.4986 62.3334 38.9989 62.3334 45.6671C62.3334 51.6676 57.4115 56.6666 50.7451 56.6666C43.4432 56.6666 38.0477 50.6661 38.0477 41.5005C38.0477 20.6678 52.9672 12.3347 62.3334 11.3333V20.4988C55.9827 21.6651 48.8427 28.1643 48.5229 35.3352C48.8427 35.1703 50.1096 34.4986 51.6963 34.4986ZM19.3194 34.4986C25.666 34.4986 29.9525 38.9989 29.9525 45.6671C29.9525 51.6676 25.0306 56.6666 18.3641 56.6666C11.0622 56.6666 5.66675 50.6661 5.66675 41.5005C5.66675 20.6678 20.5863 12.3347 29.9525 11.3333V20.4988C23.6017 21.6651 16.4617 28.1643 16.142 35.3352C16.4617 35.1703 17.7287 34.4986 19.3194 34.4986Z"
        fill="#050505"/>
    </svg>
  )

  return (
    <li
      className='slide'
      data-orbit-slide={index}>
      <div className='user-testimonial-content'>
        <div className='testimonial'>
          <div className='testimonial-header'>
            {quoteIcon}
            <img
              className='user-profile-picture'
              src={profilePicture}
            />
          </div>

          <div className='quote-container'>
            <span>
              {quote}
            </span>
          </div>
        </div>

        <div className='user-info'>
          <span className='user-name'>{name}</span>
          <span className='user-affiliation'>{affiliation}</span>
        </div>
      </div>
    </li>
  )
}

export default Testimonial;